// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__JZJ1k","footer":"ChangeClinic_footer__dCLTK"};